import en from './en-US'
import tr from './tr-TR'

export default {
    tr: { translation: tr },
    en: { translation: en },
}

// import enGB from 'date-fns/locale/en-GB';

// const Calendar = {
//     sunday: 'Pz',
//     monday: 'Pt',
//     tuesday: 'Sa',
//     wednesday: 'Ça',
//     thursday: 'Pe',
//     friday: 'Cu',
//     saturday: 'Ct',
//     ok: 'Tamam',
//     today: 'Bugün',
//     yesterday: 'Dün',
//     hours: 'Saatler',
//     minutes: 'Dakikalar',
//     seconds: 'Saniyeler',
//     /**
//      * Format of the string is based on Unicode Technical Standard #35:
//      * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
//      **/
//     formattedMonthPattern: 'MMM yyyy',
//     formattedDayPattern: 'dd MMM yyyy',
//     dateLocale: enGB
// };

// const trTR = {
//     common: {
//         loading: 'Yükleniyor...',
//         emptyMessage: 'Veri bulunamadı'
//     },
//     Plaintext: {
//         unfilled: 'Boş',
//         notSelected: 'Seçili Değil',
//         notUploaded: 'Yüklenemedi'
//     },
//     Pagination: {
//         more: 'Daha Fazla',
//         prev: 'Geri',
//         next: 'İleri',
//         first: 'İlk',
//         last: 'Son',
//         limit: '{0} / sayfa',
//         total: 'Satır Sayısı: {0}',
//         skip: 'Git{0}'
//     },
//     Calendar,
//     DatePicker: {
//         ...Calendar
//     },
//     DateRangePicker: {
//         ...Calendar,
//         last7Days: 'Son 7 Gün'
//     },
//     Picker: {
//         noResultsText: 'Sonuç bulunamadı',
//         placeholder: 'Seç',
//         searchPlaceholder: 'Ara',
//         checkAll: 'Hepsi'
//     },
//     InputPicker: {
//         newItem: 'Yeni Öğe',
//         createOption: 'Yeni Seçenek "{0}"'
//     },
//     Uploader: {
//         inited: 'Başlıyor',
//         progress: 'Yükleniyor',
//         error: 'Hata',
//         complete: 'Bitti',
//         emptyFile: 'Boş',
//         upload: 'Yükle'
//     },
//     CloseButton: {
//         closeLabel: 'Kapat'
//     },
//     Breadcrumb: {
//         expandText: 'Yolu Göster'
//     },
//     Toggle: {
//         on: 'Açık',
//         off: 'Kapalı'
//     }
// };

// export default { trTR }